export const GAME = 'GAME';
export const WIN = 'WIN';
